module.exports = __webpack_public_path__ + "static/media/question-mark-icon.23a442ef.svg";